if (!customElements.get('mdv-image-grid-slider')) {
  customElements.define(
    'mdv-image-grid-slider',
    class MDVImageGridSlider extends HTMLElement {
      connectedCallback() {
        if (this._initObserver || this.swiper) return;
        var rect = this.getBoundingClientRect();
        var nearViewport = rect.top < window.innerHeight + 200 && rect.bottom > -200;
        if (nearViewport || !('IntersectionObserver' in window)) {
          this.init();
          return;
        }
        this._initObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.init();
              this._initObserver.disconnect();
            }
          });
        }, { rootMargin: '200px 0px', threshold: 0 });
        this._initObserver.observe(this);
      }
      disconnectedCallback() {
        if (this._initObserver) this._initObserver.disconnect();
      }
      init() {
        this.swiper = new Swiper(this.querySelector('.swiper'), {
          slidesPerView: 1.2,
          loop: false,
          spaceBetween: 15,
          centeredSlides: false,
            slidesOffsetBefore:15,
            slidesOffsetAfter:15,
          breakpoints: {
            620: {
              slidesPerView: 2.2
            }
          }
        });
      }
    }
  );
}